import { styled } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import AppBarHeader from '../appBarHeader';
import DrawerAside from '../drawerAside';
import BoxTheme from '../../generic/box';
import { useContext, useState } from 'react';
import React from 'react';
import { ThemeContext } from '../../../contexts/ThemeContext';

export default function Home({ children, name }) {
    const {menu: open, handleMenu : setOpen} = useContext(ThemeContext)
    // const [open, setOpen] = useState(menu);

    const handleDrawerOpen = () => {
        setOpen(true);
    };

    const handleDrawerClose = () => {
        setOpen(false);
    };

    const DrawerHeader = styled('div')(({ theme }) => ({
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        padding: theme.spacing(0, 1),
        ...theme.mixins.toolbar,
        minHeight: "35px !important"
    }));

    return (
        <BoxTheme sx={{ display: 'flex', bgcolor:'#e0eaff' }}>
            <CssBaseline />
            <AppBarHeader open={open} handleDrawerOpen={handleDrawerOpen}
            handleDrawerClose={handleDrawerClose} />
            <DrawerAside name={name} open={open} className={open ? "open-menu" : "open-menu"} handleDrawerClose={handleDrawerClose} handleDrawerOpen={handleDrawerOpen} />
            <BoxTheme component="main" sx={{ flexGrow: 1, p: 5, height: '100vh', overflow: 'auto' }}>
                <DrawerHeader sx={{padding:'0px'}}/>
                {children}
            </BoxTheme>
        </BoxTheme>
    );
}